// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CupSection_wrapper__5fBUy","text":"CupSection_text__xCgxf"};